import { SelectOption } from '@app/shared/models/multiselect-options.model';
import { createReducer, on } from '@ngrx/store';
import { countriesListActions } from '../actions/countries-list.actions';

export interface CountriesState {
    countries: SelectOption[] | null;
    loaded: boolean | null;
    loading: boolean | null;
}

export const initialState: CountriesState = {
    countries: null,
    loaded: null,
    loading: null,
};

export const countriesReducer = createReducer(
    initialState,
    on(
        countriesListActions.getCountriesList,
        (state): CountriesState => ({
            ...state,
            loading: true,
            loaded: null,
        }),
    ),
    on(
        countriesListActions.getCountriesListSuccess,
        (state, { payload }): CountriesState => ({
            ...state,
            countries: payload,
            loading: false,
            loaded: true,
        }),
    ),
    on(
        countriesListActions.getCountriesListError,
        (state): CountriesState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),
    on(countriesListActions.clear, (): CountriesState => initialState),
);
